import { axiosInstance as axios } from "services";

export const fetchMaterialPersonel = async () => {
  const { data } = await axios.get("/supplier/materialPersonel");
  if (!data.success) throw new Error(data.error || "Failed to fetch material personel");
  return data;
};

